(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[23],{

/***/ "05v4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ESCAPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ARROW_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ARROW_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ARROW_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARROW_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HOME; });
// export const BACKSPACE = 8;
// export const SPACE = 32;
var ENTER = 13;
var ESCAPE = 27;
var ARROW_LEFT = 37;
var ARROW_UP = 38;
var ARROW_RIGHT = 39;
var ARROW_DOWN = 40;
var END = 35;
var HOME = 36;

/***/ }),

/***/ "8soX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isSymbol2 = __webpack_require__("WRsE");

var _isSymbol3 = _interopRequireDefault(_isSymbol2);

var _isString2 = __webpack_require__("gggU");

var _isString3 = _interopRequireDefault(_isString2);

var _isPlainObject2 = __webpack_require__("rLo2");

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

exports.isFSA = isFSA;
exports.isError = isError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFSA(action) {
  return (0, _isPlainObject3.default)(action) && ((0, _isString3.default)(action.type) || (0, _isSymbol3.default)(action.type)) && Object.keys(action).every(isValidKey);
}

function isError(action) {
  return action.error === true;
}

function isValidKey(key) {
  return ['type', 'payload', 'error', 'meta'].indexOf(key) > -1;
}

/***/ }),

/***/ "A5Hi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ SliderHandler_SliderHandler; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.helper.js
function getIndexInRange(index, max) {
  if (index < 0) {
    return 0;
  }

  return index < max ? index : max;
}
// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandlerItems.jsx
var __jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */


// $FlowFixMe
var SliderHandlerItems = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var children = props.children,
      className = props.className,
      hasControls = props.hasControls,
      isSwiping = props.isSwiping,
      itemPercentSize = props.itemPercentSize,
      onSwipeEnd = props.onSwipeEnd,
      onSwipeMove = props.onSwipeMove,
      onSwipeStart = props.onSwipeStart,
      position = props.position;
  return __jsx("div", {
    className: classnames_default()(className, 'overflow-hidden'),
    ref: ref,
    tabIndex: hasControls ? 0 : -1
  }, __jsx("div", {
    className: classnames_default()('flex h-full will-change-transform', {
      'transition-transform': !isSwiping
    }),
    style: {
      transform: "translate(".concat(position, "%, 0)"),
      WebkitTapHighlightColor: 'transparent'
    },
    onTouchStart: onSwipeStart,
    onTouchMove: onSwipeMove,
    onTouchEnd: onSwipeEnd
  }, react["Children"].map(children, function (child, idx) {
    return __jsx("div", {
      "aria-hidden": child.props.ariaHidden,
      className: "max-w-full image-responsive-cell will-change-transform",
      key: idx,
      style: {
        minWidth: "".concat(itemPercentSize, "%"),
        maxWidth: "".concat(itemPercentSize, "%")
      },
      tabIndex: child.props.tabIndex
    }, child);
  })));
});
// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx







var SliderHandler_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var SliderHandler_SliderHandler = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(SliderHandler, _Component);

  var _super = _createSuper(SliderHandler);

  function SliderHandler(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, SliderHandler);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onNext", function (event) {
      if (event) {
        event.preventDefault();
      }

      var _this$state = _this.state,
          maxIndex = _this$state.maxIndex,
          index = _this$state.index;

      var i = index + _this.getStep();

      if (i > maxIndex) {
        i = _this.props.hasInfiniteScroll ? 0 : maxIndex;
      }

      _this.goToIndex(i, _this.props.onNext);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onPrevious", function (event) {
      if (event) {
        event.preventDefault();
      }

      var _this$state2 = _this.state,
          maxIndex = _this$state2.maxIndex,
          index = _this$state2.index;
      var min = 0;

      var i = index - _this.getStep();

      if (i < min) {
        i = _this.props.hasInfiniteScroll ? maxIndex + i + 1 : min;
      }

      _this.goToIndex(i, _this.props.onPrevious);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyUp", function (event) {
      var isRTL = _this.state.isRTL;

      if (_this.props.hasKeyboardSupport) {
        switch (event.which) {
          case keyCodes["c" /* ARROW_RIGHT */]:
            event.stopPropagation();
            isRTL ? _this.onPrevious(event) : _this.onNext(event);
            break;

          case keyCodes["b" /* ARROW_LEFT */]:
            event.stopPropagation();
            isRTL ? _this.onNext(event) : _this.onPrevious(event);
            break;

          default:
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeStart", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        var swipeStart = _this.getSwipeX(event);

        var slideWidth = _this.sliderRef.current ? _this.sliderRef.current.offsetWidth : 0;

        _this.setState(function (_ref) {
          var lastIndex = _ref.lastIndex;
          return {
            slideWidth: slideWidth,
            isSwiping: true,
            swipeStart: swipeStart,
            swipeX: lastIndex,
            swipeStartTime: new Date()
          };
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeMove", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        var x = _this.getSwipeX(event);

        _this.setState(function (prevState) {
          var prevItemsToRender = prevState.itemsToRender,
              lastIndex = prevState.lastIndex,
              swipeStart = prevState.swipeStart,
              slideWidth = prevState.slideWidth,
              maxIndex = prevState.maxIndex,
              isRTL = prevState.isRTL;
          var offset = swipeStart - x;
          var percentageOffset = offset / slideWidth;
          var swipeX = isRTL ? lastIndex - percentageOffset : lastIndex + percentageOffset;
          var index = getIndexInRange(Math.round(swipeX), maxIndex);

          var itemsToRender = _this.getItemsToRender(prevItemsToRender, index, _this.props.nbItemsToShow);

          return _objectSpread({
            swipeX: getIndexInRange(swipeX, maxIndex)
          }, itemsToRender && {
            itemsToRender: itemsToRender
          });
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeEnd", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        _this.setState(function (prevState) {
          var prevItemsToRender = prevState.itemsToRender,
              lastIndex = prevState.lastIndex,
              swipeStartTime = prevState.swipeStartTime,
              swipeX = prevState.swipeX,
              maxIndex = prevState.maxIndex;

          var step = _this.getStep();

          var timeElapsed = new Date().getTime() - swipeStartTime.getTime();
          var offset = lastIndex - swipeX;
          var velocity = Math.round(offset / timeElapsed * 10000);
          var index = Math.round(swipeX);

          if (Math.abs(velocity) > 5) {
            index = velocity < 0 ? lastIndex + step : lastIndex - step;
          }

          var itemsToRender = _this.getItemsToRender(prevItemsToRender, index, _this.props.nbItemsToShow);

          return _objectSpread({
            index: getIndexInRange(index, maxIndex),
            isSwiping: false,
            swipeStart: 0,
            swipeX: 0
          }, itemsToRender && {
            itemsToRender: itemsToRender
          });
        }, function () {
          var _this$state3 = _this.state,
              index = _this$state3.index,
              lastIndex = _this$state3.lastIndex;
          var _this$props = _this.props,
              onPrevious = _this$props.onPrevious,
              onNext = _this$props.onNext;

          if (index < lastIndex && onPrevious) {
            onPrevious();
          } else if (index > lastIndex && onNext) {
            onNext();
          }

          _this.setState(function () {
            return {
              lastIndex: index
            };
          });
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "isItemVisible", function (itemIndex) {
      var index = _this.state.index;
      return itemIndex >= index && itemIndex < index + _this.props.nbItemsToShow;
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "shouldRenderItem", function (itemIndex) {
      return !_this.props.hasLazyload || _this.state.itemsToRender[itemIndex];
    });

    _this.sliderRef = /*#__PURE__*/Object(react["createRef"])();
    _this.state = _this.initState(props);
    return _this;
  }

  Object(createClass["a" /* default */])(SliderHandler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props2 = this.props,
          hasAutoplay = _this$props2.hasAutoplay,
          hasKeyboardSupport = _this$props2.hasKeyboardSupport;

      if (hasKeyboardSupport && this.sliderRef.current) {
        this.sliderRef.current.addEventListener('keyup', this.onKeyUp, false);
      }

      if (hasAutoplay) {
        this.intervalId = setInterval(function () {
          return _this2.onNext();
        }, 3000);
      }

      if (Object(lodash["get"])(document, 'documentElement.dir', 'ltr') === 'rtl') {
        this.setState({
          isRTL: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var hasKeyboardSupport = this.props.hasKeyboardSupport;

      if (hasKeyboardSupport && this.sliderRef.current) {
        this.sliderRef.current.removeEventListener('keyup', this.onKeyUp, false);
      }

      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }
  }, {
    key: "initState",
    value: function initState(props) {
      var hasLazyload = props.hasLazyload,
          initialIndex = props.initialIndex,
          items = props.items,
          nbItemsToShow = props.nbItemsToShow;
      var itemsCount = items.length;
      var maxIndex = itemsCount < nbItemsToShow ? 0 : itemsCount - nbItemsToShow;
      var index = getIndexInRange(initialIndex, maxIndex);
      var initialItemsToRender = Array(itemsCount).fill(!hasLazyload, 0, itemsCount);
      var itemsToRender = this.getItemsToRender(initialItemsToRender, index, nbItemsToShow);
      return {
        index: index,
        isSwiping: false,
        isRTL: false,
        itemsCount: itemsCount,
        itemsToRender: itemsToRender,
        lastIndex: index,
        maxIndex: maxIndex,
        slideWidth: 0,
        swipeStart: 0,
        swipeStartTime: new Date(),
        swipeX: 0
      };
    }
  }, {
    key: "getItemsToRender",
    value: function getItemsToRender(itemsToRender, index, nbItemsToShow) {
      var hasLazyload = this.props.hasLazyload;
      var step = this.getStep();
      var minRange = index - step;
      var maxRange = index + nbItemsToShow + step;
      var newItemToRender = itemsToRender.map(function (isRendered, itemIndex) {
        return isRendered || Object(lodash["inRange"])(itemIndex, minRange, maxRange);
      });

      if (!hasLazyload || itemsToRender.every(function (isRendered) {
        return isRendered;
      }) || Object(lodash["isEqual"])(itemsToRender, newItemToRender)) {
        return itemsToRender;
      }

      return newItemToRender;
    }
  }, {
    key: "getStep",
    value: function getStep() {
      var _this$props$nbItemsTo = this.props.nbItemsToScroll,
          nbItemsToScroll = _this$props$nbItemsTo === void 0 ? 1 : _this$props$nbItemsTo;
      return nbItemsToScroll > 0 ? nbItemsToScroll : 1;
    } // Slide

  }, {
    key: "getItemPosition",
    value: function getItemPosition() {
      var _this$state4 = this.state,
          index = _this$state4.index,
          swipeX = _this$state4.swipeX,
          isSwiping = _this$state4.isSwiping,
          isRTL = _this$state4.isRTL;
      var x = isSwiping ? swipeX : index;
      var posX = x * 100 / this.props.nbItemsToShow;
      return isRTL ? posX : -posX;
    }
  }, {
    key: "goToIndex",
    value: function goToIndex(index) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : lodash["noop"];
      this.setState(function (prevState) {
        var itemsToRender = _this3.getItemsToRender(prevState.itemsToRender, index, _this3.props.nbItemsToShow);

        return {
          index: index,
          itemsToRender: itemsToRender,
          lastIndex: index
        };
      }, callback);
    } // Events handlers

  }, {
    key: "getSwipeX",
    // Swipe
    value: function getSwipeX(event) {
      return event.touches[0].pageX;
    }
  }, {
    key: "isFirstItemVisible",
    value: function isFirstItemVisible() {
      return this.isItemVisible(0);
    }
  }, {
    key: "isLastItemVisible",
    value: function isLastItemVisible() {
      var itemsCount = this.state.itemsCount;
      return this.isItemVisible(itemsCount - 1);
    }
  }, {
    key: "hasControls",
    value: function hasControls() {
      return this.state.itemsCount > this.props.nbItemsToShow;
    }
  }, {
    key: "render",
    // render
    value: function render() {
      var _this4 = this;

      var _this$state5 = this.state,
          index = _this$state5.index,
          isSwiping = _this$state5.isSwiping,
          itemsCount = _this$state5.itemsCount;
      if (!itemsCount) return null;
      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className,
          hasInfiniteScroll = _this$props3.hasInfiniteScroll,
          items = _this$props3.items,
          nbItemsToShow = _this$props3.nbItemsToShow;
      var hasControls = this.hasControls();

      var itemsNode = SliderHandler_jsx(SliderHandlerItems, {
        className: className,
        hasControls: hasControls,
        isSwiping: isSwiping,
        itemPercentSize: 100 / nbItemsToShow,
        onSwipeEnd: this.onSwipeEnd,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        position: this.getItemPosition(),
        ref: this.sliderRef
      }, items.map(function (item, idx) {
        return _this4.shouldRenderItem(idx) ? /*#__PURE__*/Object(react["cloneElement"])(item, {
          ariaHidden: !_this4.isItemVisible(idx),
          tabIndex: -1
        }) : null;
      }).filter(Boolean));

      var childrenProps = {
        hasControls: hasControls,
        index: index,
        isNextControlDisabled: !hasInfiniteScroll && this.isLastItemVisible(),
        isPreviousControlDisabled: !hasInfiniteScroll && this.isFirstItemVisible(),
        itemsNode: itemsNode,
        onNext: this.onNext,
        onPrevious: this.onPrevious
      };
      return children(childrenProps);
    }
  }]);

  return SliderHandler;
}(react["Component"]);

Object(defineProperty["a" /* default */])(SliderHandler_SliderHandler, "defaultProps", {
  initialIndex: 0,
  nbItemsToScroll: 1,
  nbItemsToShow: 1
});

/***/ }),

/***/ "CwUp":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("ZWmQ");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "DQFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSlideShow; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("u/u4");
/* harmony import */ var _arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Gy6l");
/* harmony import */ var _backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("NZxu");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("0IQ5");
/* harmony import */ var _slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("A5Hi");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;







var ImageSlideShow = function ImageSlideShow(_ref) {
  var className = _ref.className,
      closeLabel = _ref.closeLabel,
      galleryLabel = _ref.galleryLabel,
      _ref$groupKey = _ref.groupKey,
      groupKey = _ref$groupKey === void 0 ? 'thumbnails' : _ref$groupKey,
      hasControlsOnHover = _ref.hasControlsOnHover,
      hasFullScreenMode = _ref.hasFullScreenMode,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      hasInsetBorder = _ref.hasInsetBorder,
      hasLazyLoading = _ref.hasLazyLoading,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].XL : _ref$ratio;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false),
      isFullScreen = _useState[0],
      setIsFullScreen = _useState[1];

  if (!media.length) {
    return null;
  }

  var gk = hasFullScreenMode ? null : groupKey;
  var ItemTagName = hasFullScreenMode ? 'button' : 'div';
  var itemProps = hasFullScreenMode ? {
    className: 'reset-button block w-full',
    onClick: function onClick() {
      return setIsFullScreen(true);
    },
    type: 'button'
  } : null;
  var items = media.map(function (_ref2) {
    var _ref2$alt = _ref2.alt,
        alt = _ref2$alt === void 0 ? '' : _ref2$alt,
        src = _ref2.src;
    return src ? __jsx(ItemTagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
      key: src
    }, itemProps), __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"], {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
        'inset-border-after': hasInsetBorder
      }),
      altMsg: alt,
      groupKey: gk,
      hasLazyLoading: hasLazyLoading,
      imageUrl: src,
      key: src,
      ratioKey: ratio
    })) : null;
  }).filter(Boolean);
  return __jsx(_slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_7__[/* SliderHandler */ "a"], {
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: items
  }, function (_ref3) {
    var hasControls = _ref3.hasControls,
        isNextControlDisabled = _ref3.isNextControlDisabled,
        isPreviousControlDisabled = _ref3.isPreviousControlDisabled,
        itemsNode = _ref3.itemsNode,
        onNext = _ref3.onNext,
        onPrevious = _ref3.onPrevious;
    return __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'group relative')
    }, itemsNode, hasControls && __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('transition-opacity will-change-transform absolute flex items-center justify-between max-w-site m-auto inset-0 pointer-events-none px-3 sm:px-5 w-full z-2', {
        'group-hover:opacity-100 opacity-0': hasControlsOnHover
      }),
      "data-testid": "ImageSlideShow-controls-parent"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__[/* ArrowButton */ "a"], {
      className: "rtl:mr-auto pointer-events-auto shadow-sm z-2",
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__[/* ArrowButton */ "a"], {
      className: "rtl:ml-auto pointer-events-auto shadow-sm z-2",
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })), hasFullScreenMode && isFullScreen && __jsx(_backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_5__[/* Backdrop */ "a"], {
      ariaLabel: galleryLabel,
      closeLabel: closeLabel,
      hasCloseButton: true,
      onClose: function onClose() {
        return setIsFullScreen(false);
      }
    }, __jsx("div", {
      className: "relative w-full"
    }, itemsNode, hasControls && __jsx("div", {
      className: "absolute flex items-center justify-between m-auto inset-0 pointer-events-none px-3 sm:px-5 w-full"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__[/* ArrowButton */ "a"], {
      className: "rtl:mr-auto pointer-events-auto shadow-sm z-2",
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__[/* ArrowButton */ "a"], {
      className: "rtl:ml-auto pointer-events-auto shadow-sm z-2",
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })))));
  });
};

/***/ }),

/***/ "Ebpn":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "EvYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Modal_Modal; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/modal/Modal.themes.js
var MAX_HEIGHT = '70vh';
var sizes = {
  auto: 'auto',
  small: '23.75rem',
  medium: '40rem',
  large: '50rem'
};
var themes = function themes(_ref) {
  var size = _ref.size;
  return {
    "default": {
      thRoot: 'fadeIn flex relative scaleIn',
      thRootStyles: {
        width: sizes[size],
        maxWidth: '100%',
        maxHeight: MAX_HEIGHT,
        minHeight: 100
      },
      thCloseButton: 'absolute bg-white border-1 cursor-pointer leading-none top-0 mb-3 rtl:right-0 p-1 reset-button rounded-full z-1',
      thCloseButtonLabel: 'sr-only',
      thCloseButtonStyles: {
        top: 'auto',
        bottom: '100%',
        width: 40,
        height: 40
      },
      thBody: 'bg-white max-h-full relative overflow-hidden rounded-tiny shadow w-full',
      thBodyStyles: {
        maxHeight: MAX_HEIGHT
      },
      // ⚠️ relative is only needed to prevent a weird bug of reflow on chrome
      thContent: 'max-h-full overflow-auto relative w-full'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/modal/Modal.jsx
var __jsx = react_default.a.createElement;






var Modal_Modal = function Modal(_ref) {
  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      backdropColor = _ref.backdropColor,
      backdropOpacity = _ref.backdropOpacity,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      id = _ref.id,
      onClose = _ref.onClose,
      portalName = _ref.portalName,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var modalButtonRef = Object(react["useRef"])();
  var closeBtnModal = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  Object(react["useEffect"])(function () {
    modalButtonRef.current && modalButtonRef.current.focus();
  }, []);
  var _themes$theme = themes({
    size: size
  })[theme],
      thBody = _themes$theme.thBody,
      thBodyStyles = _themes$theme.thBodyStyles,
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thCloseButtonStyles = _themes$theme.thCloseButtonStyles,
      thCloseIconWidth = _themes$theme.thCloseIconWidth,
      thContent = _themes$theme.thContent,
      thRoot = _themes$theme.thRoot,
      thRootStyles = _themes$theme.thRootStyles;
  return __jsx(Backdrop["a" /* Backdrop */], {
    ariaLabel: ariaLabel,
    ariaLabelledby: ariaLabelledby,
    bgColor: backdropColor,
    onClose: onClose,
    opacity: backdropOpacity,
    portalName: portalName
  }, __jsx("aside", {
    className: thRoot,
    id: id,
    style: thRootStyles
  }, __jsx("button", {
    className: thCloseButton,
    "data-testid": "Modal-close",
    onClick: onClose,
    ref: modalButtonRef,
    style: thCloseButtonStyles,
    type: "button"
  }, closeBtnModal && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnModal), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), __jsx("div", {
    className: thBody,
    style: thBodyStyles
  }, __jsx("div", {
    className: classnames_default()(className, thContent)
  }, children))));
};

/***/ }),

/***/ "LwQZ":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("Ebpn");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "NXDx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInstalmentPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrencySymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTotalPriceWithDonation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasAtLeastOnePrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isLongFormat; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wz9x");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var MAX_LENGTH = 10;

function getCurrencySymbol(locale, currency) {
  return 0 .toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).replace(/\d/g, '').trim();
}

function hasPrice(price) {
  return !!(price === null || price === void 0 ? void 0 : price.value);
}

var hasDiscount = function hasDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      initialPrice = _ref.initialPrice;
  return hasPrice(initialPrice) && hasPrice(bestPrice) && (initialPrice === null || initialPrice === void 0 ? void 0 : initialPrice.value) !== (bestPrice === null || bestPrice === void 0 ? void 0 : bestPrice.value);
};

function hasAtLeastOnePrice() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref2 = props || {},
      initialPrice = _ref2.initialPrice,
      bestPrice = _ref2.bestPrice;

  return hasPrice(initialPrice) || hasPrice(bestPrice);
}

function isLongFormat(amount) {
  return amount ? amount.toString().length > MAX_LENGTH : false;
}

var getTotalPriceWithDonation = function getTotalPriceWithDonation(price, locale) {
  var donation = price.donation,
      total = price.total,
      totalWithoutDiscount = price.totalWithoutDiscount;
  var totalWithDonation = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(donation, 'value', 0) + Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(total, 'value', 0);
  var totalWithoutDiscountWithDonation = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(donation, 'value', 0) + Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(totalWithoutDiscount, 'value', 0);
  var currencyOptions = {
    precision: Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__["getBookingPrecision"])(locale)
  };
  return _objectSpread(_objectSpread({}, price), {}, {
    withDonation: {
      total: {
        value: totalWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_2__[/* formatAmountForLocale */ "b"])(totalWithDonation, locale, price.currency, currencyOptions)
      },
      totalWithoutDiscount: {
        value: totalWithoutDiscountWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_2__[/* formatAmountForLocale */ "b"])(totalWithoutDiscountWithDonation, locale, price.currency, currencyOptions)
      },
      hasFlexRates: price.hasFlexRates,
      selectedRate: price.selectedRate
    }
  });
};

var getInstalmentPrice = function getInstalmentPrice(price, locale) {
  if (!price || !price.value) return '';

  if (Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* getKeyValue */ "c"])('common.price.displayInstalmentsPrice')) {
    var instalmentValue = Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* getKeyValue */ "c"])('common.price.instalmentValue');
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])('common.price.instalmentPrice', {
      instalmentValue: instalmentValue,
      dividedPrice: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_2__[/* formatAmountForLocale */ "b"])(Math.ceil(price.value / instalmentValue), locale, price.currency, {
        precision: 0
      })
    });
  }

  return price.formattedValue;
};


/***/ }),

/***/ "NZxu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Backdrop; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-focus-on/dist/es2015/Combination.js + 8 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-focus-lock/dist/es2015/MoveFocusInside.js
var MoveFocusInside = __webpack_require__("oweP");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/frameworks/backdrop/Backdrop.themes.js
var themes = {
  "default": {
    thCloseButton: 'reset-button bg-white flex items-center justify-center leading-none m-5 rtl:right-0 rtl:slideInRight rounded-tiny shadow text-gray-darker text-sm transition-colors',
    thCloseButtonStyle: {
      width: 28,
      height: 28
    },
    thCloseButtonLabel: 'sr-only'
  },
  lite: {
    thCloseButton: 'reset-button bg-white cursor-pointer leading-none mt-5 mx-5 md:mx-12 p-4 rtl:right-0 rounded-full text-gray-darker text-md rtl:slideInRight',
    thCloseButtonLabel: 'sr-only'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx
var __jsx = react_default.a.createElement;









function Backdrop(props) {
  var ariaLabel = props.ariaLabel,
      ariaLabelledby = props.ariaLabelledby,
      _props$bgColor = props.bgColor,
      bgColor = _props$bgColor === void 0 ? '#000' : _props$bgColor,
      children = props.children,
      className = props.className,
      closeLabel = props.closeLabel,
      externalFocusTrapRefs = props.externalFocusTrapRefs,
      hasCloseButton = props.hasCloseButton,
      hasNoFocusTrap = props.hasNoFocusTrap,
      onClose = props.onClose,
      _props$opacity = props.opacity,
      opacity = _props$opacity === void 0 ? 0.8 : _props$opacity,
      _props$portalName = props.portalName,
      portalName = _props$portalName === void 0 ? Portal_constants["b" /* AFTER_APP */] : _props$portalName,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thCloseButtonStyle = _themes$theme.thCloseButtonStyle;
  var closeBtnLabel = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  return __jsx(Portal["a" /* default */], {
    name: portalName
  }, __jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: true
  }, __jsx("div", {
    className: classnames_default()(className, 'fadeIn fixed inset-0 escape-responsive-helper z-3')
  }, __jsx("div", {
    className: "fixed h-screen inset-0 z-1",
    "data-testid": "Backdrop-overlay",
    style: {
      backgroundColor: bgColor,
      opacity: opacity
    }
  }), __jsx("div", {
    "aria-label": ariaLabelledby ? null : ariaLabel,
    "aria-labelledby": ariaLabelledby,
    role: "dialog"
  }, __jsx("div", {
    role: "document"
  }, hasCloseButton ? __jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: !hasNoFocusTrap,
    onEscapeKey: onClose,
    shards: externalFocusTrapRefs
  }, __jsx(MoveFocusInside["a" /* default */], null, __jsx("button", {
    className: classnames_default()('absolute top-0 z-3', thCloseButton),
    "data-testid": "Backdrop-close",
    onClick: onClose,
    title: closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : null,
    type: "button",
    style: thCloseButtonStyle
  }, closeBtnLabel && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnLabel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "1em"
  }))), __jsx("div", {
    className: "absolute flex items-center justify-center inset-0 z-2"
  }, children)) : __jsx("div", {
    className: "absolute flex items-center justify-center inset-0 p-5 z-2"
  }, __jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    className: "max-w-full",
    enabled: !hasNoFocusTrap,
    onClickOutside: onClose,
    onEscapeKey: onClose,
    shards: externalFocusTrapRefs
  }, children)))))));
}

/***/ }),

/***/ "NqXy":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("UXnz");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "O+76":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "UXnz":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("LwQZ");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "WRsE":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("ceqt"),
    isObjectLike = __webpack_require__("O+76");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ "ZWmQ":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "b0q8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.resolve = resolve;
exports.reject = reject;
exports.unresolve = unresolve;
exports.unreject = unreject;
exports.isResolvedAction = isResolvedAction;
exports.isRejectedAction = isRejectedAction;
exports.isThenAction = isThenAction;
exports.default = optimistPromiseMiddleware;

var _fluxStandardAction = __webpack_require__("8soX");

function isPromise(val) {
  return val && typeof val.then === 'function';
}

var RESOLVED_NAME = '_RESOLVED',
    REJECTED_NAME = '_REJECTED';

var BEGIN = 'BEGIN';
var COMMIT = 'COMMIT';
var REVERT = 'REVERT';

function resolve(actionName) {
  return actionName + RESOLVED_NAME;
}

function reject(actionName) {
  return actionName + REJECTED_NAME;
}

function unresolve(resolvedActionName) {
  return resolvedActionName.split(RESOLVED_NAME)[0];
}

function unreject(rejectedActionName) {
  return rejectedActionName.split(REJECTED_NAME)[0];
}

function isResolvedAction(resolvedActionName) {
  return unresolve(resolvedActionName) !== resolvedActionName;
}

function isRejectedAction(rejectedActionName) {
  return unreject(rejectedActionName) !== rejectedActionName;
}

function isThenAction(thenActionName) {
  return isResolvedAction(thenActionName) || isRejectedAction(thenActionName);
}

function optimistPromiseMiddleware() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$throwOnReject = _ref.throwOnReject,
      throwOnReject = _ref$throwOnReject === undefined ? true : _ref$throwOnReject,
      _ref$resolvedName = _ref.resolvedName,
      resolvedName = _ref$resolvedName === undefined ? RESOLVED_NAME : _ref$resolvedName,
      _ref$rejectedName = _ref.rejectedName,
      rejectedName = _ref$rejectedName === undefined ? REJECTED_NAME : _ref$rejectedName;

  RESOLVED_NAME = resolvedName;
  REJECTED_NAME = rejectedName;

  var nextTransactionID = 0;
  return function (_ref2) {
    var dispatch = _ref2.dispatch;
    return function (next) {
      return function (action) {
        if (!(0, _fluxStandardAction.isFSA)(action) || !action.meta || !isPromise(action.meta.promise)) {
          return next(action);
        }

        var isOptimist = action.meta.optimist;

        var transactionID = void 0;

        if (isOptimist) {
          transactionID = nextTransactionID++;
        }

        // (1) Dispatch actionName with meta with arguments apart from promise

        // Clone original action
        var newAction = _extends({}, action, {
          meta: _extends({}, action.meta)
        });

        if (isOptimist) {
          // Adding optimistic meta
          newAction.optimist = { type: BEGIN, id: transactionID };
          delete newAction.meta.optimist;
        }

        if (Object.keys(newAction.meta).length === 1) {
          delete newAction.meta;
        } else {
          // Other arguments, delete promise and optimist only
          delete newAction.meta.promise;
        }

        var skipOptimist = action.meta.skipOptimist;

        if (!skipOptimist) {
          next(newAction);
        }

        // Create a base for the next action containing the metadata.
        var nextActionBase = {
          meta: _extends({}, newAction.meta, {
            payload: newAction.payload
          })
        };

        if (!nextActionBase.meta.payload) {
          // No payload, no need to include them in the meta.
          delete nextActionBase.meta.payload;
        }
        if (Object.keys(nextActionBase.meta).length === 0) {
          // No meta was included either, remove all meta.
          delete nextActionBase.meta;
        }

        // (2) Listen to promise and dispatch payload with new actionName
        return action.meta.promise.then(function (result) {
          var actionToDispatch = _extends({
            type: resolve(action.type),
            payload: result
          }, nextActionBase);
          if (isOptimist) {
            actionToDispatch.optimist = { type: COMMIT, id: transactionID };
          }
          dispatch(actionToDispatch);
          return result;
        }).catch(function (error) {
          var actionToDispatch = _extends({
            type: reject(action.type),
            payload: error
          }, nextActionBase);
          if (isOptimist) {
            actionToDispatch.optimist = { type: REVERT, id: transactionID };
          }
          dispatch(actionToDispatch);
          if (throwOnReject) {
            throw error;
          }
        });
      };
    };
  };
}

/***/ }),

/***/ "ceqt":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("UXnz"),
    getRawTag = __webpack_require__("NqXy"),
    objectToString = __webpack_require__("jAAP");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "gggU":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("ceqt"),
    isArray = __webpack_require__("laNg"),
    isObjectLike = __webpack_require__("O+76");

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ "jAAP":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "laNg":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "oweP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("aWzz");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("R6jJ");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("s5tn");
/* harmony import */ var _medium__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("7LZv");







function MoveFocusInside(_ref) {
  var isDisabled = _ref.disabled,
      className = _ref.className,
      children = _ref.children;
  var ref = react__WEBPACK_IMPORTED_MODULE_1___default.a.useRef(null);
  var disabled = react__WEBPACK_IMPORTED_MODULE_1___default.a.useRef(isDisabled);

  var moveFocus = function moveFocus() {
    var observed = ref.current;
    _medium__WEBPACK_IMPORTED_MODULE_5__[/* mediumEffect */ "b"].useMedium(function (car) {
      if (!disabled.current && observed) {
        if (!car.focusInside(observed)) {
          car.moveFocusInside(observed, null);
        }
      }
    });
  };

  react__WEBPACK_IMPORTED_MODULE_1___default.a.useEffect(function () {
    disabled.current = isDisabled;
    moveFocus();
  }, [isDisabled]);
  return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, Object(_util__WEBPACK_IMPORTED_MODULE_4__[/* inlineProp */ "b"])(focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__[/* FOCUS_AUTO */ "b"], !isDisabled), {
    ref: ref,
    className: className
  }), children);
}

MoveFocusInside.propTypes =  false ? undefined : {};
MoveFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (MoveFocusInside);

/***/ }),

/***/ "rLo2":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("ceqt"),
    getPrototype = __webpack_require__("CwUp"),
    isObjectLike = __webpack_require__("O+76");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ })

}]);